import { requestType } from '~/config/enum.config';
var SERVICE = 'repair-service';
var CONTROLLER = 'phoneNumberData';
export default {
    searchPhoneNumber: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'searchPhoneNumber',
        type: requestType.Get
    },
};
